const post = {
  slug: "ml-ai-coming-soon",
  title: "ML/AI Engineering Transition — Coming Soon",
  date: "2026-03-16",
  category: "ml-ai-transition",
  tags: ["ML/AI", "Career Transition"],
  excerpt:
    "Articles on transitioning from senior software engineering to ML/AI — coming soon.",
  isPlaceholder: true,
  content: `
I'm working on a series of articles about my journey transitioning from senior software engineering into ML/AI. Topics will include:

- **Understanding Transformers** — explained for backend engineers
- **Training Loops as ETL Pipelines** — mapping ML concepts to systems you already know
- **Building Your First RAG Application** — from zero to working prototype
- **LLM Tool Calling and Agents** — practical patterns for production AI

Stay tuned — the first post is on its way.
`,
};

export default post;